namespace TabAurous.OMS {
    export namespace ProcessSelectService {
        export const baseUrl = 'OMS/ProcessSelect';

        export declare function List(request: ProcessRequest, onSuccess?: (response: Serenity.ListResponse<ProcessMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "OMS/ProcessSelect/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>ProcessSelectService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
